import ProductsTypeSelection from './ProductsTypeSelection';

export default ProductsTypeSelection;